export enum PusherEventOperation {
  NONE,
  CREATE,
  UPDATE,
  DESTROY,
}
